import { createSelector } from 'reselect';
import some from 'lodash/some';
import get from 'lodash/get';

export const selectDependentManagementState = state =>
  get(state, 'dependentManagement');

/**
 *  PENDING ASSIGNMENTS
 * */
export const selectPendingAssignmentState = createSelector(
  selectDependentManagementState,
  state => get(state, 'assignmentPending'),
);

export const selectPendingAssignmentList = createSelector(
  selectPendingAssignmentState,
  state => get(state, 'list', []),
);

export const selectPendingAssignmentListPagination = createSelector(
  selectPendingAssignmentState,
  state => get(state, 'pagination', {}),
);

export const selectPendingAssignmentListCount = createSelector(
  selectPendingAssignmentState,
  state => get(state, 'count'),
);

/**
 *  REVIEWED ASSIGNMENTS
 * */

export const selectReviewedAssignmentState = createSelector(
  selectDependentManagementState,
  state => get(state, 'assignmentReviewed'),
);

export const selectReviewedAssignmentList = createSelector(
  selectReviewedAssignmentState,
  state => get(state, 'list', []),
);

export const selectReviewedAssignmentListPagination = createSelector(
  selectReviewedAssignmentState,
  state => get(state, 'pagination', {}),
);

export const selectReviewedAssignmentListCount = createSelector(
  selectReviewedAssignmentState,
  state => get(state, 'count'),
);

export const selectAssignmentListLoading = createSelector(
  selectReviewedAssignmentState,
  selectPendingAssignmentState,
  (...states) => some(states, ({ sending }) => sending),
);

/**
 *  UPDATE ASSIGNMENT
 * */

export const selectUpdateAssignmentState = createSelector(
  selectDependentManagementState,
  state => get(state, 'assignmentUpdate'),
);

export const selectUpdateAssignmentLoading = createSelector(
  selectUpdateAssignmentState,
  state => get(state, 'sending'),
);



// WEBPACK FOOTER //
// ./src/redux/dependentManagement/selectors.js